import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";

import { GlobalFooter } from "./globalFooter";

import "./pageLayout.scss";
export type PageLayoutProps = {
  readonly banner?: React.ReactNode;
  readonly content?: React.ReactNode;
  readonly sideNav?: React.ReactNode;
};

const DefaultSideNav = () => <div>Side Nav</div>;
const DefaultBanner = () => <div>Banner</div>;

export const PageLayout: FunctionComponent<PageLayoutProps> = ({
  banner = <DefaultBanner />,
  sideNav = <DefaultSideNav />,
  content
}) => {
  const contentWrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isContentScrolled, setIsContentScrolled] = useState(false);

  const handleContentScroll = useCallback(() => {
    const isScrolled =
      (contentWrapperRef.current?.scrollTop ?? 0) > 0 ||
      (contentRef.current?.scrollTop ?? 0) > 0;

    setIsContentScrolled((currentValue) =>
      currentValue === isScrolled ? currentValue : isScrolled
    );
  }, []);

  useEffect(() => {
    handleContentScroll();
  }, [handleContentScroll]);

  return (
    <div
      className={`cnc-shell${
        isContentScrolled ? " cnc-shell-content-scrolled" : ""
      }`}
    >
      <div className="cnc-banner">{banner}</div>
      <div className="cnc-page-layout">
        <div className="cnc-side-nav">{sideNav}</div>
        <div
          className="cnc-content-wrapper"
          onScroll={handleContentScroll}
          ref={contentWrapperRef}
        >
          <div
            className="cnc-content"
            onScroll={handleContentScroll}
            ref={contentRef}
          >
            {content}
          </div>
          <GlobalFooter />
        </div>
      </div>
    </div>
  );
};
